import { Component, input } from '@angular/core';

@Component({
  selector: 'lib-pegase-tag',
  standalone: true,
  templateUrl: './tag.component.html',
  styleUrl: './tag.component.scss',
})
export class TagComponent {
  public type = input<'success'|'error'|'alert'|'info'|'neutral'>();
}
